module.exports = __webpack_public_path__ + "static/img/example8.4c36807.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/chainmanage/image/example8.jpg
// module id = 714
// module chunks = 1